import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { RasporedLjudiService } from './raspored-ljudi.service';
// import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { moduli } from '../../config';

const pdfMake = require('pdfmake/build/pdfmake.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-raspored-ljudi',
  templateUrl: './raspored-ljudi.component.html',
  styleUrls: ['./raspored-ljudi.component.scss'],
  providers: [RasporedLjudiService],
})
export class RasporedLjudiComponent implements OnInit {
  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: RasporedLjudiService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }
    this.smjene = [
      { id: '', naziv: 'SVE' },
      { id: 1, naziv: '1' },
      { id: 2, naziv: '2' },
      { id: 3, naziv: '3' },
    ];
    this.linije = [{ id: '', naziv: 'SVE' }];

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().rasporedLjudi;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  linije: any;
  smjene: any;
  djelatnici: any;
  poruka: string;
  sviDjelatnici: any;
  odabranaLinijaId: any;
  odabranaLinijaNaziv: string;
  ubaciDjelatnikaPopupVisible = false;
  odabraniDjelatnik: any;
  obrisiDjelatnikaPopupVisible = false;
  idDjelatnik: any;
  today: Date = new Date();
  dateBoxNedjelja = moment().day(0);
  odabranaSmjena: any;
  odabraniDatum: any;
  //16.05.2023. zatraženo da se može odabrati i ponedjeljak a ne samo nedjelja kako je bilo do sada
  //nedjelja = moment().day(0).format('YYYY-MM-DD');
  //petak = moment().day(5).format('YYYY-MM-DD');
  startDay = moment().day(0).format('YYYY-MM-DD');
  startDayPrikaz = moment(this.startDay).format('DD.MM.YYYY.');
  endDay = moment().day(5).format('YYYY-MM-DD');
  endDayPrikaz = moment(this.endDay).format('DD.MM.YYYY.');
  djelatnikFormaPoruka: string;
  radnici: any = [];
  tjedan: number;
  pocetakSmjene: any;
  krajSmjene: any;
  pocetakSmjeneSlanje: string;
  krajSmjeneSlanje: string;
  napomena: string;
  popupZatvoren = false;
  smjenaFilter: any;
  linijaFilter: any;
  disableGumb: boolean = false;

  ngOnInit() {
    this.tjedanUGodini(this.startDay, this.endDay);
    this.dohvatiSveLinije();
    this.dohvatiSveDjelatnike();
    this.dohvatiDjelatnike(this.startDay, this.endDay, '', '');
  }

  disableDates(args) {
    const dayOfWeek = args.date.getDay();
    //16.05.2023. zatraženo da se može odabrati i ponedjeljak a ne samo nedjelja kako je bilo do sada
    const notSunday = args.view === 'month' && dayOfWeek !== 0 && dayOfWeek !== 1;

    return notSunday;
  }

  tjedanUGodini(startDay, endDay) {
    this.service.tjedanUGodini({ datumod: startDay, datumdo: endDay }).subscribe((res) => {
      //console.log(res);
      this.tjedan = res.data[0].tjedanugodini;
      //console.log(this.tjedan);
    });
  }

  kreirajRaspored(): void {
    let data = {
      datumod: this.startDay,
      datumdo: this.endDay,
      tjedanugodini: this.tjedan,
    };
    //console.log(data);
    this.service.kreirajRaspored(data).subscribe((res) => {
      //console.log(res);
      if (res.data[0][0].rezultat === 1) {
        this.dohvatiDjelatnike(
          this.startDay,
          this.endDay,
          this.smjenaFilter,
          this.linijaFilter
        );
        notify('Uspješno kreiranje rasporeda.', 'success', 3000);
      } else if (res.data[0][0].rezultat === 0) {
        notify('Nema djelatnika u prethodnom tjednu!', 'warning', 3000);
      } else {
        notify('Došlo je do pogreške!', 'error', 3000);
      }
    });
  }

  dohvatiSveDjelatnike() {
    this.sviDjelatnici = [];
    this.service.dohvatiSveDjelatnike({}).subscribe((res) => {
      //console.log(res);
      for (let data of res.data) {
        this.sviDjelatnici.push({
          iddjelatnik: data.idsec_users,
          ime: data.name
        });
      }
      //console.log(this.sviDjelatnici);
    });
  }

  dohvatiSveLinije() {
    this.service.dohvatiSveLinije({}).subscribe((res) => {
      //console.log(res);
      this.linije = [{ id: '', naziv: 'SVE' }];
      if (res.success == true) {
        for (let linija of res.data) {
          // console.log(linija);
          this.linije.push({
            id: linija.idlinija,
            naziv: linija.li_naziv,
          });
        }
        // console.log(this.linije);
      }
    });
  }

  dohvatiDjelatnike(datumOd, datumDo, smjena, linija) {
    this.poruka = 'Učitavanje...';
    let data = {
      datumod: datumOd,
      datumdo: datumDo,
      linija: linija,
      smjena: smjena,
    };
    //console.log(data);
    this.service.dohvatiDjelatnike(data).subscribe((res) => {
      //console.log(res);
      this.djelatnici = [];
      if (res.success == true) {
        if (res.data.length == 0) {
          this.poruka = 'Nema dodjeljenih djelatnika!';
        } else {
          this.poruka = 'Učitavanje...';
        }
        for (let data of res.data) {
          this.djelatnici.push({
            idDjelatnik: data.idlinijadjelatnik,
            djelatnik: data.ld_djelatnik,
            datumod: data.datumod,
            datumodPrikaz: moment(data.datumod).format('DD.MM.YYYY.'),
            datumdo: data.datumdo,
            datumdoPrikaz: moment(data.datumdo).format('DD.MM.YYYY.'),
            smjena: data.smjena_idsmjena,
            linijaId: data.linija_idlinija,
            linija: data.li_naziv,
            pocetakSmjene: data.ld_pocetaksmjene,
            krajSmjene: data.ld_krajsmjene,
            radnoVrijeme: data.ld_pocetaksmjene.slice(0, -3) + ' - ' + data.ld_krajsmjene.slice(0, -3),
            napomena: data.ld_napomena,
          });
        }
      } else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
  }

  dohvatiDjelatnika(data) {
    //console.log(data);
  }

  promjenaPocetkaSmjene(e) {
    // console.log(e);
    this.pocetakSmjeneSlanje = moment(e.value).format('HH:mm:ss');
    // console.log(this.pocetakSmjeneSlanje);
  }

  promjenaKrajaSmjene(e) {
    // console.log(e);
    this.krajSmjeneSlanje = moment(e.value).format('HH:mm:ss');
    // console.log(this.krajSmjeneSlanje);
  }

  promjenaNapomene(e) {
    // console.log(e);
    this.napomena = e.value;
    // console.log(this.napomena);
  }

  dodajDjelatnikaPopup() {
    this.ubaciDjelatnikaPopupVisible = true;
    this.popupZatvoren = false;
    this.djelatnikFormaPoruka = 'Dodavanje djelatnika';
    this.idDjelatnik = undefined;
    this.odabraniDjelatnik = undefined;
    this.odabranaLinijaId = null;
    this.odabranaSmjena = null;
    this.radnici = [];
    this.pocetakSmjene = '';
    this.krajSmjene = '';
    this.napomena = '';
    this.disableGumb = false;
  }

  urediDjelatnikaPopup(data) {
    //console.log(data);
    this.ubaciDjelatnikaPopupVisible = true;
    this.popupZatvoren = false;
    this.djelatnikFormaPoruka = 'Uređivanje djelatnika';
    this.idDjelatnik = data.data.idDjelatnik;
    this.odabraniDjelatnik = data.data.djelatnik;
    this.odabranaLinijaId = data.data.linijaId;
    this.odabranaSmjena = data.data.smjena;
    this.radnici = [];
    this.pocetakSmjene = moment(data.data.pocetakSmjene, 'HH:mm:ss');
    this.krajSmjene = moment(data.data.krajSmjene, 'HH:mm:ss');
    this.napomena = data.data.napomena;
  }

  odaberiDjelatnika(e) {
    //console.log(e);
    this.odabraniDjelatnik = e.value;
    if (this.odabraniDjelatnik) {
      this.provjeraDjelatnikaPoTjednu(this.odabraniDjelatnik, this.tjedan);
    }
  }

  provjeraDjelatnikaPoTjednu(djelatnik, tjedan) {
    //console.log(djelatnik);
    this.service
      .provjeraDjelatnikaPoTjednu({
        iddjelatnik: djelatnik.iddjelatnik,
        tjedanugodini: tjedan,
      })
      .subscribe((res) => {
        //console.log(res);
        if (res.data.length) {
          notify('Djelatnik je već dodan u odabrani tjedan!', 'warning', 3000);
        } else {
          if (!this.provjeraPostojeciRadnik(this.odabraniDjelatnik)) {
            this.radnici.push({
              iddjelatnik: this.odabraniDjelatnik.iddjelatnik,
              djelatnik: this.odabraniDjelatnik.ime,
            });
          } else {
            notify('Odabrani djelatnik je na popisu.', 'warning', 3000);
          }
          //console.log(this.radnici);
        }
      });
  }

  ukloniRadnika(index) {
    this.radnici.splice(index, 1);
  }

  promjenaDjelatnika() {
    this.odabraniDjelatnik = undefined;
  }

  provjeraPostojeciRadnik(djelatnik) {
    return this.radnici.some(function (el) {
      return el.iddjelatnik === djelatnik.iddjelatnik;
    });
  }

  onPopupClosed() {
    this.popupZatvoren = true;
  }

  dodajDjelatnika() {
    this.disableGumb = true;
    let data = {
      datumod: this.startDay,
      datumdo: this.endDay,
      linija: this.odabranaLinijaId,
      smjena: this.odabranaSmjena,
      radnici: this.radnici,
      tjedanugodini: this.tjedan,
      pocetaksmjene: this.pocetakSmjeneSlanje,
      krajsmjene: this.krajSmjeneSlanje,
      napomena: this.napomena,
    };
    //console.log(data);
    this.service.spremiDjelatnika(data).subscribe((res) => {
      //console.log(res);
      this.disableGumb = false;
      if (res.success === true) {
        this.dohvatiDjelatnike(this.startDay, this.endDay, '', '');
        this.radnici = [];
        this.ubaciDjelatnikaPopupVisible = false;
        notify('Uspješno dodavanje djelatnika!', 'success', 3000);
      }
    });
  }

  urediDjelatnika() {
    let data = {
      idlinijadjelatnik: this.idDjelatnik,
      datumod: this.startDay,
      datumdo: this.endDay,
      linija: this.odabranaLinijaId,
      smjena: this.odabranaSmjena,
      djelatnik: this.odabraniDjelatnik,
      tjedanugodini: this.tjedan,
      pocetaksmjene: this.pocetakSmjeneSlanje,
      krajsmjene: this.krajSmjeneSlanje,
      napomena: this.napomena,
    };
    //console.log(data);
    this.service.urediDjelatnika(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.dohvatiDjelatnike(this.startDay, this.endDay, '', '');
        this.odabraniDjelatnik = '';
        this.ubaciDjelatnikaPopupVisible = false;
        notify('Uspješno uređivanje djelatnika!', 'success', 3000);
      }
    });
  }

  obrisiDjelatnikaPopup(data) {
    this.obrisiDjelatnikaPopupVisible = true;
    //console.log(data);
    this.idDjelatnik = data.data.idDjelatnik;
  }

  obrisiDjelatnika() {
    this.service
      .obrisiDjelatnika({ idlinijadjelatnik: this.idDjelatnik })
      .subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.dohvatiDjelatnike(this.startDay, this.endDay, '', '');
          this.obrisiDjelatnikaPopupVisible = false;
          notify('Uspješno brisanje djelatnika!', 'success', 3000);
        }
      });
  }

  onCellClick(e) {
    // console.log(e);
    if (e.columnIndex != 0) {
      e.event.stopImmediatePropagation();
    }
  }

  promjenaDatuma(e) {
    //console.log(e);
    //console.log(e.value);
    //console.log(moment(e.value).format('dddd'));
    this.odabraniDatum = moment(e.value).format('YYYY-MM-DD');
    this.startDay = moment(e.value).format('YYYY-MM-DD');
    this.startDayPrikaz = moment(e.value).format('DD.MM.YYYY.');
    let dana = 5;
    if (moment(e.value).format('dddd') === 'Monday'){
      dana += 1;
    }
    this.endDay = moment(e.value).day(dana).format('YYYY-MM-DD');
    this.endDayPrikaz = moment(e.value).day(dana).format('DD.MM.YYYY.');
    this.tjedanUGodini(this.startDay, this.endDay);
    this.dohvatiDjelatnike(
      this.startDay,
      this.endDay,
      this.smjenaFilter,
      this.linijaFilter
    );
  }

  promjenaSmjene(e) {
    // console.log(e);
    this.odabranaSmjena = e.value;
    if (!this.ubaciDjelatnikaPopupVisible) {
      if (!this.popupZatvoren) {
        this.dohvatiDjelatnike(
          this.startDay,
          this.endDay,
          this.smjenaFilter,
          this.linijaFilter
        );
      }
    } else {
      if (this.odabranaSmjena === 1) {
        this.pocetakSmjene = moment('00:00', 'HH:mm')
          .add(6, 'hours')
          .toISOString(true);
        this.krajSmjene = moment('00:00', 'HH:mm')
          .add(14, 'hours')
          .toISOString(true);
      } else if (this.odabranaSmjena === 2) {
        this.pocetakSmjene = moment('00:00', 'HH:mm')
          .add(14, 'hours')
          .toISOString(true);
        this.krajSmjene = moment('00:00', 'HH:mm')
          .add(22, 'hours')
          .toISOString(true);
      } else if (this.odabranaSmjena === 3) {
        this.pocetakSmjene = moment('00:00', 'HH:mm')
          .add(22, 'hours')
          .toISOString(true);
        this.krajSmjene = moment('00:00', 'HH:mm')
          .add(6, 'hours')
          .toISOString(true);
      }
    }
  }

  promjenaLinije(e) {
    // console.log(e);
    this.odabranaLinijaId = e.value;
    if (!this.ubaciDjelatnikaPopupVisible) {
      if (!this.popupZatvoren) {
        this.dohvatiDjelatnike(
          this.startDay,
          this.endDay,
          this.smjenaFilter,
          this.linijaFilter
        );
      }
    }
  }

  promjenaSmjeneFilter(e) {
    this.smjenaFilter = e.value;
    this.dohvatiDjelatnike(
      this.startDay,
      this.endDay,
      this.smjenaFilter,
      this.linijaFilter
    );
  }

  promjenaLinijeFilter(e) {
    this.linijaFilter = e.value;
    this.dohvatiDjelatnike(
      this.startDay,
      this.endDay,
      this.smjenaFilter,
      this.linijaFilter
    );
  }

  disableItem(e) {
    if (this.ubaciDjelatnikaPopupVisible) {
      this.smjene[0].disabled = true;
      this.linije[0].disabled = true;
    } else {
      this.smjene[0].disabled = false;
      this.linije[0].disabled = false;
    }
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift(
      {
        location: 'before',
        template: 'naslovTablice',
      },
      {
        location: 'after',
        template: 'odabirDatuma',
      },
      {
        location: 'after',
        template: 'odabirSmjene',
      },
      {
        location: 'after',
        template: 'odabirLinije',
      }
    );
  }

  onCellPrepared(options) {
    // console.log(options);
    if (options.rowType == "data") {
      if (options.column.dataField === "smjena"){
        if (options.value == '1') {
          options.cellElement.classList.add('bojaSmjena1');
        }
        if (options.value == '2') {
          options.cellElement.classList.add('bojaSmjena2');
        }
        if (options.value == '3') {
          options.cellElement.classList.add('bojaSmjena3');
        }
      }
    }
  }

  // PDF EXPORT RASPORED LJUDI
  exportPdf() {
    //console.log(this.linije);
    //console.log(this.djelatnici);

    let l = [];
    let ln = '';
    let s1 = [];
    let s2 = [];
    let s3 = [];
    let linije = [];

    for (let item of this.djelatnici) {
      for (let linija of this.linije) {
        if (linija.naziv === item.linija) {
          linije.push(linija.naziv);
          var filtriraneLinije = [...new Set(linije)];
        }
      }
    }

    let ct = [];

    ct.push({
      text: this.startDayPrikaz + ' - ' + this.endDayPrikaz,
      alignment: 'center',
      fontSize: 19,
    });
    ct.push({ text: '\n' });

    for (let linija of filtriraneLinije) {
      s1 = [];
      s2 = [];
      s3 = [];
      for (let item of this.djelatnici) {
        if (linija === item.linija && item.smjena === 1) {
          ln = linija;
          s1.push({
            table: {
              widths: ['*', '*'],
              body: [
                [
                  {
                    text: item.datumodPrikaz + ' - ' + item.datumdoPrikaz + '\n' + item.radnoVrijeme,
                    fillColor: '#eeeeee',
                    alignment: 'center',
                    fontSize: 10
                  },
                  {
                    text:
                      item.djelatnik +
                      '\n' +
                      (item.napomena ? '(' + item.napomena + ')' : ''),
                  },
                ],
              ],
            },
            layout: 'noBorders',
          });
        }
        if (linija === item.linija && item.smjena === 2) {
          ln = linija;
          s2.push({
            table: {
              widths: ['*', '*'],
              body: [
                [
                  {
                    text: item.datumodPrikaz + ' - ' + item.datumdoPrikaz + '\n' + item.radnoVrijeme,
                    fillColor: '#eeeeee',
                    alignment: 'center',
                    fontSize: 10
                  },
                  {
                    text:
                      item.djelatnik +
                      '\n' +
                      (item.napomena ? '(' + item.napomena + ')' : ''),
                  },
                ],
              ],
            },
            layout: 'noBorders',
          });
        }
        if (linija === item.linija && item.smjena === 3) {
          ln = linija;
          s3.push({
            table: {
              widths: ['*', '*'],
              body: [
                [
                  {
                    text: item.datumodPrikaz + ' - ' + item.datumdoPrikaz + '\n' + item.radnoVrijeme,
                    fillColor: '#eeeeee',
                    alignment: 'center',
                    fontSize: 10
                  },
                  {
                    text:
                      item.djelatnik +
                      '\n' +
                      (item.napomena ? '(' + item.napomena + ')' : ''),
                  },
                ],
              ],
            },
            layout: 'noBorders',
          });
        }
      }

      ct.push({
        table: {
          widths: ['*', '*', '*'],
          body: [
            [{ text: ln, colSpan: 3 }, {}, {}],
            [
              { text: '1', alignment: 'center' },
              { text: '2', alignment: 'center' },
              { text: '3', alignment: 'center' },
            ],
            [s1, s2, s3],
          ],
        },
      });
      ct.push({ text: '\n' });
    }

    let docDefinition = {
      info: { title: this.startDayPrikaz + ' ' + this.endDayPrikaz },
      pageSize: 'A4',
      pageOrientation: 'landscape',
      content: ct,
    };

    pdfMake.createPdf(docDefinition).open();
  }
}
